// The clinic-line task (cc_spruce_inbound, WF84): its `context_json.spruce` stamp, read through a whitelist.

import { isClosedStatus, readTaskContext, templateCodeOf } from './task';
import { spruceThreadUrl } from './spruce';

export const SPRUCE_INBOUND_TEMPLATE = 'cc_spruce_inbound';

export type SpruceInboundKind = 'sms' | 'voicemail' | 'missed_call' | 'shared_phone';

const KINDS: readonly SpruceInboundKind[] = ['sms', 'voicemail', 'missed_call', 'shared_phone'];

export interface SpruceInbound {
  kind: SpruceInboundKind;
  receivedAt: string | null;
  threadUrl: string | null;
}

export interface SpruceTaskLike {
  status?: string | null;
  template?: { template_code?: string } | null;
  template_code?: string | null;
  context_json?: unknown;
}

// An open clinic-line task, or null. Never hands out the raw ids: only a link checked against our own org.
export function spruceInboundOf(
  task: SpruceTaskLike | null | undefined,
  configuredOrg: string | null | undefined,
): SpruceInbound | null {
  if (!task || templateCodeOf(task) !== SPRUCE_INBOUND_TEMPLATE || isClosedStatus(task.status)) return null;
  const raw = readTaskContext(task.context_json)?.spruce;
  if (!raw || typeof raw !== 'object') return null;
  const stamp = raw as Record<string, unknown>;
  const kind = KINDS.find((k) => k === stamp.kind);
  if (!kind) return null;
  const at = typeof stamp.received_at === 'string' ? Date.parse(stamp.received_at) : NaN;
  const ref = ['org', 'conversation_id', 'item_id'].every((k) => typeof stamp[k] === 'string')
    ? `spruce:${stamp.org}:${stamp.conversation_id}:${stamp.item_id}`
    : null;
  return {
    kind,
    receivedAt: Number.isFinite(at) ? new Date(at).toISOString() : null,
    threadUrl: spruceThreadUrl(configuredOrg, ref),
  };
}
